/**
 * Production-safe logging utility
 * Only logs in development mode or when DEBUG is enabled
 */

const isDev = process.env.NODE_ENV === 'development';
const isDebug = localStorage.getItem('DEBUG') === 'true';

const logger = {
  log: (...args) => {
    if (isDev || isDebug) {
      console.log(...args);
    }
  },
  
  warn: (...args) => {
    if (isDev || isDebug) {
      console.warn(...args);
    }
  },
  
  error: (...args) => {
    // Always log errors
    console.error(...args);
  },
  
  info: (...args) => {
    if (isDev || isDebug) {
      console.info(...args);
    }
  },
  
  debug: (...args) => {
    if (isDebug) {
      console.debug(...args);
    }
  },
  
  // Enable debug mode
  enableDebug: () => {
    localStorage.setItem('DEBUG', 'true');
    console.log('[Logger] Debug mode enabled. Refresh to see logs.');
  },
  
  // Disable debug mode
  disableDebug: () => {
    localStorage.removeItem('DEBUG');
    console.log('[Logger] Debug mode disabled.');
  }
};

// Expose to window for debugging in production
if (typeof window !== 'undefined') {
  window.enableDebug = logger.enableDebug;
  window.disableDebug = logger.disableDebug;
}

export default logger;
